module.exports = __webpack_public_path__ + "img/xiaoji.efafc57d.png";